'use strict';

// Service for getting the cookie and polyfill

angular.module('storyApp').factory('cookiePolyfillService', function() {
(function () {
           function CustomEvent ( event, params ) {
           params = params || { bubbles: false, cancelable: false, detail: undefined };
           var evt = document.createEvent( 'CustomEvent' );
           evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
           return evt;
           }
           CustomEvent.prototype = window.Event.prototype;

           window.CustomEvent = CustomEvent;
           })();
return {

         readCookie : function(name) {
         var nameEQ = name + "=";
         var ca = document.cookie.split(';');
         for(var i=0;i < ca.length;i++) {
           var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    }
 });
